import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "animate.css/animate.compat.css";

import { Swiper, SwiperSlide } from "swiper/react";
import "./Demo_Product.css";

import { Link, useNavigate } from "react-router-dom";

import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import Common_Category_Card from "../../common-components/common_category_card/Common_Category_Card";
import ScrollAnimation from "react-animate-on-scroll";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllCategories,
  getAllDataSubCategory,
} from "../../../features/master/masterSlice";
import { appSetup } from "../../../features/master/masterSlice";

function Demo_ProductCategory({
  products,
  breakpoints,
  setSelectId,
  selectId,
}) {
  const navigate = useNavigate();

  const allProducts = useSelector(
    (state) => state.product.allProducts?.data || [],
  );
  const dispatch = useDispatch();
  const category = useSelector((state) => state.master.all_subcategories);

  const app_setup = useSelector((state) => state.master.app_setup);

  useEffect(() => {
    dispatch(getAllDataSubCategory());
  }, [dispatch]);
  const availableCategories = category || [];

  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);

  AOS.init({ disable: "mobile" });

  const isMobile = window.innerWidth < 991;
  const [animate, setAnimate] = React.useState(false);

  useEffect(() => {
    if (isMobile) {
      setTimeout(() => setAnimate(true), 100);
    }
  }, []);

  useEffect(() => {
    dispatch(appSetup());
  }, [dispatch]);

  return (
    <section className="Demo_Product_holder">
      <div className="container-fluid">
        <div className="category_swiper_holder">
          <div className="heading_holder">
            <h4 className="heading_text">Shop By Category </h4>
          </div>

          {isMobile ? (
            // 📱 MOBILE VERSION (Animate on page load)
            <section
              className={`all_cats_section ${animate ? "fadeInLeft" : ""}`}
            >
              <div className="all_cats_div">
                <div className="row">
                  {category?.map((product, index) => (
                    <div className="col-lg-3 col-md-4 col-6 px-1" key={index}>
                      <div className="card_holder">
                        <Common_Category_Card
                          // imgSrc={process.env.REACT_APP_IMG_URL + product.image}
                          // imgSrc={
                          //   product?.image && product?.image !== ""
                          //     ? product?.image
                          //     : "/assets/images/common alex jewellery.png"
                          // }
                          imgSrc={
                            product?.image
                              ? product.image.startsWith("http")
                                ? product.image
                                : process.env.REACT_APP_IMG_URL + product.image
                              : "/assets/images/common alex jewellery.png"
                          }
                          title={product?.name}
                          catDiscount={product?.cat_discount}
                          onClick={() =>
                            // navigate("/categories", {
                            //   state: {
                            //     category_id: product?.id,
                            //   },
                            // })
                            navigate(
                              `/shops?sub_category=${product?.name || ""}`,
                            )
                          }
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </section>
          ) : (
            // 🖥 DESKTOP VERSION (Scroll animation)
            <ScrollAnimation animateIn="fadeInLeft">
              <section className="all_cats_section">
                <div className="all_cats_div">
                  <div className="row">
                    {category?.map((product, index) => (
                      <div className="col-lg-3 col-6" key={index}>
                        <div className="card_holder">
                          <Common_Category_Card
                            // imgSrc={
                            //   product?.image && product?.image !== ""
                            //     ? product?.image
                            //     : "/assets/images/common alex jewellery.png"
                            // }
                            imgSrc={
                              product?.image
                                ? product.image.startsWith("http")
                                  ? product.image
                                  : process.env.REACT_APP_IMG_URL +
                                    product.image
                                : "/assets/images/common alex jewellery.png"
                            }
                            title={product?.name}
                            catDiscount={product?.cat_discount}
                            onClick={() =>
                              // navigate("/categories", {
                              //   state: {
                              //     category_id: product?.id,
                              //   },
                              // })
                              navigate(
                                `/shops?sub_category=${product?.name || ""}`,
                              )
                            }
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </section>
            </ScrollAnimation>
          )}

          {/*old code  */}
          {/* <Swiper
            modules={[Pagination, Navigation]}
            navigation={true}
            spaceBetween={10}
            slidesPerView={4}
            pagination={{ clickable: true }}
            breakpoints={breakpoints}
            className=""
          >
            {products?.map((product, index) => (
              <SwiperSlide key={index}>
                <div className="Demo_Product">
                  <div className="product-card">
                    <div
                      className="img_holder"
                      onClick={() =>
                        navigate(`/categories?category_id=${product?.id}`)
                      }
                    >
                   
                      <img
                        className="Product_img"
                        src={process.env.REACT_APP_IMG_URL + product.image}
                        alt={product.name}
                      />
                 
                    </div>

                    <p className="product-name">{product.name}</p>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper> */}
        </div>
      </div>
    </section>
  );
}

export default Demo_ProductCategory;
